export default __webpack_public_path__ + "static/media/graphite-01.efd1a61b.png";